import React from "react";
import { Autocomplete, Checkbox, TextField } from "@mui/material";

import {
  MULTI_SELECT_LIMIT_TAGS,
  ticketPriorirityOptions
} from "../utils/constants";
import { formClasses } from "../styles/AutocompleteStyles";
import { PriorityOptionsTypes } from "../utils/types";
interface Props {
  onChange: (newValue: PriorityOptionsTypes[]) => void;
  autoCompleteValue: PriorityOptionsTypes[];
  handleClear: () => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  label: string;
}
const MultiplePrioritySelect = ({
  onChange,
  handleClear,
  onKeyDown,
  autoCompleteValue,
  label
}: Props) => {
  return (
    <>
      <Autocomplete
        className={formClasses.inputRoot}
        options={ticketPriorirityOptions}
        limitTags={MULTI_SELECT_LIMIT_TAGS}
        multiple
        onChange={(e, newValue) => {
          onChange(newValue as []);
        }}
        renderOption={(props, option) => {
          const selectedSuppliers = autoCompleteValue.map(({ value }) => value);

          const checked = selectedSuppliers.includes(
            (option as PriorityOptionsTypes).value
          );

          return (
            <li {...props} key={(option as PriorityOptionsTypes).value}>
              <Checkbox style={{ marginRight: 8 }} checked={checked} />
              {(option as PriorityOptionsTypes).label}
            </li>
          );
        }}
        onKeyDown={onKeyDown}
        openOnFocus
        forcePopupIcon
        value={autoCompleteValue}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            className={formClasses.formControlRoot}
            label={label}
            slotProps={{
              inputLabel: 
               {shrink:true}
              
            }}
          />
        )}
      />
      {/* <LoadingModal flag={loading} /> */}
    </>
  );
};

export default MultiplePrioritySelect;
